/* eslint-env mocha */
export default {
  data () {
    return {
      featuredBusinesses: [
        {
          logo: '/static/img/featured_businesses/hetzner.png',
          srcset: '/static/img/featured_businesses/hetzner@2x.png 2x, /static/img/featured_businesses/hetzner@3x.png 3x',
          name: 'Hetzner',
          slug: 'hetzner'
        },
        {
          logo: '/static/img/featured_businesses/miway.png',
          srcset: '/static/img/featured_businesses/miway@2x.png 2x, /static/img/featured_businesses/miway@3x.png 3x',
          name: 'MiWay',
          slug: 'miway'
        },
        {
          logo: '/static/img/featured_businesses/prepaid24.png',
          srcset: '/static/img/featured_businesses/prepaid24@2x.png 2x, /static/img/featured_businesses/prepaid24@3x.png 3x',
          name: 'Prepaid&nbsp;24',
          slug: 'prepaid24'
        },
        {
          logo: '/static/img/featured_businesses/king-price-insurance.png',
          srcset: '/static/img/featured_businesses/king-price-insurance@2x.png 2x, /static/img/featured_businesses/king-price-insurance@3x.png 3x',
          name: 'King&nbsp;Price&nbsp;Insurance',
          slug: 'king-price-insurance'
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/featured_businesses.js